import { Breadcrumbs as MuiBreadcrumbs, Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import React from 'react'
import { NavLink } from 'ComponentLibrary/src/piazza/text/Link/Link'
import { TextWithEllipsis, Typography } from 'ComponentLibrary/src/piazza/text'
import { ArrowLeft } from '@phosphor-icons/react'

export type BreadcrumbItem = {
    title: string
    link?: string
    params?: string
    maxWidth?: string
}

export type BreadcrumbsProps = {
    items: BreadcrumbItem[]
    currentLocation: string
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, currentLocation }) => {
    return (
        <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center">
            <MuiBreadcrumbs
                aria-label="breadcrumb"
                separator="|"
                sx={{ lineHeight: 'normal', color: tokens.ColorTextDisabled, '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' } }}
            >
                {items.map((item, index) => {
                    const link = item.params ? `${item.link}?${item.params}` : item.link
                    return link !== undefined && !item.link?.endsWith(currentLocation) && !item.link?.startsWith('.') ? (
                        <Stack key={`breadcrumb-${item.title}`} maxWidth={item.maxWidth} overflow={item.maxWidth ? 'hidden' : undefined}>
                            <NavLink
                                breadcrumbs
                                href={link}
                                label={item.title}
                                startIcon={index === 0 && <ArrowLeft size={tokens.SizingIconS} weight="bold" />}
                            />
                        </Stack>
                    ) : item.maxWidth ? (
                        <Stack key={`breadcrumb-${item.title}`} maxWidth={item.maxWidth} overflow="hidden">
                            <TextWithEllipsis
                                tooltipText={item.title}
                                placement="right"
                                typographyProps={{ variant: 'headline5', color: tokens.ColorTextDisabled, noWrap: true }}
                                fullWidth
                            >
                                {item.title}
                            </TextWithEllipsis>
                        </Stack>
                    ) : (
                        <Typography key={`breadcrumb-${item.title}`} variant="headline5" color={tokens.ColorTextDisabled} noWrap>
                            {item.title}
                        </Typography>
                    )
                })}
            </MuiBreadcrumbs>
        </Stack>
    )
}
